<template>
    <div class="p-5">
        <h2>{{ $t("vacations.edit") }}</h2>
        <form @submit.prevent="submitForm" method="post" action="" class="row w-50" autocomplete="off">
            <div class="col-12">
                <label for="warehouse" class="mt-2">{{ $t("transportations.chooseDriver") }}</label>
            </div>
            <div class="col-12">
                <select v-model="formData.userId" class="form-control form-select" id="warehouse" name="warehouse"
                    size="1">
                    <option v-for="driver in drivers" :key="driver.id" :value="driver.id">
                        {{ driver.name }}
                    </option>
                </select>
            </div>
            <div class="col-12">
                <label for="vacation_from" class="mt-2">{{ $t("vacations.from") }}</label>
            </div>
            <div class="col-12">
                <input v-model="formData.vacation_from" type="datetime-local" class="form-control" id="vacation_from"
                    name="vacation_from">
            </div>
            <div class="col-12">
                <label for="vacation_to" class="mt-2">{{ $t("vacations.to") }}</label>
            </div>
            <div class="col-12">
                <input v-model="formData.vacation_to" type="datetime-local" class="form-control" id="vacation_to"
                    name="vacation_to" placeholder="">
            </div>

            <button @click="submitForm" type="submit" class="mt-4 btn btn-primary w-100 form-submit">{{ $t("utils.add")
            }}</button>
        </form>
    </div>
</template>
<script>
export default {
    data() {
        return {
            drivers: [],
            vacationId: null,
            formData: {
                userId: null,
                vacation_from: null,
                vacation_to: null
            }
        }
    },
    created: function () {
        this.vacationId = this.$route.params.id;
        this.loadData();
    },
    methods: {
        loadData() {
            this.$store.getters.api.get("/drivers").then((response) => {
                this.drivers = response.data.items;
            });
            this.$store.getters.api.get("/user_vacation/" + this.vacationId).then((response) => {
                this.formData.userId = response.data.item.user.id;
                this.formData.vacation_from = response.data.item.vacation_from;
                this.formData.vacation_to = response.data.item.vacation_to;
            });
        },
        submitForm() {
            const payload = {
                user: this.formData.userId,
                vacation_from: this.formData.vacation_from,
                vacation_to: this.formData.vacation_to
            };
            this.$store.getters.api.put("/user_vacation/" + this.vacationId + "/edit", payload)
                .then((response) => {
                    this.$router.push({ "name": "UserVacations" });
                });
        }
    },

}
</script>
<style scoped lang="scss"></style>